export const COMMANDE_NOCA_RESET = "COMMANDE_NOCA_RESET";
export const COMMANDE_NOCA_SET_ERROR = "COMMANDE_NOCA_SET_ERROR";
export const COMMANDE_NOCA_SET_ITEMS = "COMMANDE_NOCA_SET_ITEMS";
export const COMMANDE_NOCA_TOGGLE_LOADING = "COMMANDE_NOCA_TOGGLE_LOADING";
